import { resultsConfig } from '@Constants/Results';
import * as Results from '@Services/Results';
import * as FormatUtils from '@Services/FormatUtils';
import { parseRelativeIndex } from '@Containers/PatentFamilyClustering/utils';

const _citRefResultNames = {};
const _targetsTotal = {};

const _calculateIndexes = (countOfCurrentItems, totalItems, count) => {
  let firstItem;
  let lastItem;

  if (countOfCurrentItems > 0) {
    lastItem = countOfCurrentItems + count;
    firstItem = countOfCurrentItems + 1;
    lastItem = lastItem <= totalItems ? lastItem : totalItems;
  } else {
    firstItem = 1;
    lastItem = totalItems <= count ? totalItems : count;
  }

  return { firstItem, lastItem };
};

export const getTargetsTotal = (resultId) => _targetsTotal[resultId];

export const getItemsForCitations = ({
  resultName,
  semanticSearchIncluded,
  semanticResultName,
  resultIndex,
  resultRelativeIndex, // Patent Family Clustering
  countOfCurrentItems,
  totalItems,
  databaseId,
  sort,
  order,
  context,
  count = 9,
  hitData = false,
  ignoreCitRef = false,
}) => {
  const { firstItem, lastItem } = _calculateIndexes(countOfCurrentItems, totalItems, count);

  // Generic results
  let resultId = `${resultName}/${resultIndex}`;
  let firstSubItem;

  // Patent Family Clustering
  if (resultRelativeIndex) {
    resultId = `${resultName}/${resultRelativeIndex}`;
    // eslint-disable-next-line no-param-reassign
    [resultIndex, firstSubItem] = parseRelativeIndex(resultRelativeIndex);
  }

  const citRef = !ignoreCitRef && _citRefResultNames[resultId] ? _citRefResultNames[resultId] : null;

  return Results.getRelativeResultsForCitations(
    resultIndex,
    context,
    resultName,
    databaseId,
    firstItem,
    lastItem,
    sort,
    order,
    citRef,
    hitData,
    firstSubItem,
    semanticSearchIncluded,
    semanticResultName
  )
    .then((data) => {
      if (!data || !data.entities) return undefined;

      if (context === resultsConfig.CONTEXT.targets) {
        if (!_citRefResultNames[resultId]) {
          _citRefResultNames[resultId] = data.citRefResultName;
        }
        if (!_targetsTotal[resultId]) {
          _targetsTotal[resultId] = data.totalResultSize;
        }
      }

      return Object.values(FormatUtils.formatEntitiesByContext(context, data.entities));
    })
    .catch(Logger.reject);
};
